var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { TextField } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
export var StyledTextField = styled(TextField)({
    '&&': {
        width: 250
    }
});
export var RightWrapper = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 5px;\n"], ["\n  display: flex;\n  gap: 5px;\n"])));
export var NavigationWrapper = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: 5px;\n"], ["\n  display: flex;\n  gap: 5px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CalendarToolBar.Styles.js.map